/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authState from "./feature/auth/authSlice";
import trackingLinksState from "./feature/tracking-links/trackingLinkSlice";
import referralPartnersState from "./feature/referral-partners/referralPartnerSlice";
import partnerTrackingState from "./feature/partner-tracking/partnerTrackingSlice";
import partnerDetailsState from "./feature/partner-details/partnerDetailsSlice";
import partnerApprovalState from "./feature/partner-approval/partnerApprovalSlice";

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
const persistUserConfig = {
  key: "authState",
  storage: storage,
  whitelist: ["userState"],
  blacklist: [
    "isLogin",
    "isRegister",
    "partnerIsWaiting",
    "partnerIsRejected",
    "isForgotPassword",
    "errorMessage",
    "successMessage",
    "errorResetMessage",
    "successResetMessage",
  ],
};

export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    authState: persistReducer(persistUserConfig, authState),
    trackingLinksState,
    referralPartnersState,
    partnerTrackingState,
    partnerDetailsState,
    partnerApprovalState,
    ...injectedReducers,
  });

  return rootReducer;
}
